import React, { useRef } from "react";
import { Controller } from "react-hook-form";
import { InputNumber } from "primereact/inputnumber";
import { classNames } from "primereact/utils";
import { FloatLabel } from "primereact/floatlabel";

const NumberInput = ({
  name,
  label,
  control,
  errors,
  max,
  type,
  mode,
  prefix,
  suffix,
  placeholder,
  minFractionDigits,
  maxFractionDigits,
  tooltip,
  tooltipOptions,
  rules,
  defaultValue,
  onChange,
  required,
  min,
  disabled,
  onBlur,
  currency,
  locale,
  useGrouping,
  validationRules,
  maxLength,
}) => {
  // Usando ref para o InputNumber
  const inputRef = useRef(null);

  // Função para mover o cursor para o início
  const handleFocus = () => {
    if (inputRef.current && inputRef.current.input) {
      inputRef.current.input.setSelectionRange(0, 0);
    }
  };

  return (
    <Controller
      name={name}
      control={control}
      rules={{
        required: required ? "Campo obrigatório." : false,
        ...validationRules,
      }}
      render={({ field, fieldState }) => (
        <>
          <label
            htmlFor={field.name}
            className={fieldState.error ?? "p-error"}
          ></label>
          <FloatLabel className="w-100">
            <InputNumber
              style={{ marginTop: 0 }} // Remove a margem superior
              ref={inputRef} // Usando a ref no componente InputNumber
              name={field.name}
              id={field.name}
              prefix={prefix}
              suffix={suffix}
              mode={mode}
              currency={currency}
              locale={locale}
              type={type}
              disabled={disabled}
              autoClear={true}
              value={field.value !== undefined ? field.value : null}
              placeholder={placeholder}
              defaultValue={defaultValue || ""}
              max={max}
              min={min !== undefined ? min : null}
              maxLength={maxLength}
              tooltip={tooltip}
              tooltipOptions={tooltipOptions}
              minFractionDigits={minFractionDigits}
              maxFractionDigits={maxFractionDigits}
              useGrouping={useGrouping ? true : false}
              className={`w-100 ${fieldState.error ?? "is-invalid"}`}
              onChange={(e) => {
                field.onChange(e.value);
                onChange && onChange(e);
              }}
              onFocus={handleFocus} // Evento onFocus para garantir o início do cursor
              onBlur={onBlur}
              onValueChange={(e) => field.onChange(e.value)}
            />
            <label htmlFor={field.name}>{label}</label>
          </FloatLabel>
          {errors && errors[name] && (
            <span className="p-error">{errors[name].message}</span>
          )}
        </>
      )}
    />
  );
};

export default NumberInput;
